import { TemplateElement, html, defineElement } from '@webtides/element-js';

/**
 * @property {string} title
 * @property {string} url
 * @property {string} message
 */
export default class ShareButton extends TemplateElement {
    /** @type TooltipElement */
    tooltipElement;

    constructor() {
        super({ shadowRender: true });
    }

    properties() {
        return {
            title: document.title,
            url: window.location.href,
            message: '',
        };
    }

    connected() {
        this.tooltipElement = this.$refs.tooltip;
    }

    events() {
        return {
            this: {
                click: (e) => {
                    e.preventDefault();
                    if (navigator.share) {
                        navigator
                            .share({
                                title: this.title,
                                url: this.url,
                            })
                            .then(() => {
                                this.tooltipElement.show();
                            })
                            .catch(console.error);
                    } else {
                        this.copyToClipboard();
                    }
                },
                focusout: () => {
                    this.tooltipElement.hide();
                },
            },
        };
    }

    copyToClipboard() {
        navigator.clipboard.writeText(this.url).then(() => {
            this.tooltipElement.show();
        });
    }

    template() {
        return html`
            <tooltip-element ref="tooltip" trigger="manual" content="${this.message}">
                <slot></slot>
            </tooltip-element>
        `;
    }
}

defineElement('share-button', ShareButton);
